import { Link } from "react-router-dom";
import LogoMark from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0A0C]">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-16 md:py-24">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <LogoMark className="h-9 w-9" />
              <span className="font-display font-extrabold tracking-[0.18em]">DAFITEXCHANGE</span>
            </div>
            <p className="text-sm text-white/45 leading-relaxed mt-5">
              Performance gym and fitness wear for men and women. No shortcuts, no excuses —
              just gear that shows up as hard as you do.
            </p>
          </div>
          <div className="flex gap-16 md:gap-24">
            <div>
              <p className="text-[10px] tracking-[0.3em] text-white/35 mb-5">SHOP</p>
              <ul className="space-y-3 text-sm">
                <li><Link data-testid="footer-link-men" to="/shop?cat=men" className="text-white/60 hover:text-[#D3FF24] transition-colors">Men</Link></li>
                <li><Link data-testid="footer-link-women" to="/shop?cat=women" className="text-white/60 hover:text-[#D3FF24] transition-colors">Women</Link></li>
                <li><Link data-testid="footer-link-accessories" to="/shop?cat=accessories" className="text-white/60 hover:text-[#D3FF24] transition-colors">Accessories</Link></li>
              </ul>
            </div>
            <div>
              <p className="text-[10px] tracking-[0.3em] text-white/35 mb-5">BRAND</p>
              <ul className="space-y-3 text-sm">
                <li><Link data-testid="footer-link-all" to="/shop" className="text-white/60 hover:text-[#D3FF24] transition-colors">Full Arsenal</Link></li>
                <li><span className="text-white/60">dafitexchange.com</span></li>
              </ul>
            </div>
          </div>
        </div>
        <p className="font-display font-black text-outline text-[13vw] leading-none tracking-tighter mt-16 select-none">
          DAFITEXCHANGE
        </p>
        <div className="flex flex-col md:flex-row justify-between gap-3 border-t border-white/10 mt-10 pt-6">
          <p className="text-[10px] tracking-[0.25em] text-white/30">© 2026 DAFITEXCHANGE.COM — ALL RIGHTS RESERVED</p>
          <p className="text-[10px] tracking-[0.25em] text-white/30">GRIND NEVER STOPS</p>
        </div>
      </div>
    </footer>
  );
}
